import CircleIcon from '@material-ui/icons/FiberManualRecord';
import { statusColors } from '../Constants/constants';

export function ControllerIdentity({ controller }) {
  const status = controller?.connection?.status ?? 'bad';
  const name = controller?.simulation
    ? `${controller.name} (simulation)`
    : (controller?.name ?? '');

  return (
    <>
      <CircleIcon data-testid="controller-status" style={{ color: statusColors[status] }} />
      {name}
    </>
  );
}
